<template>
  <div class="z-main">
    <header class="z-header">
      <div>
        <router-link to="/index"><img src="../../assets/sysbars/left.png" /></router-link>
      </div>
      <div v-text="currTitle"></div>
      <div>&nbsp;</div>
    </header>
    <div class="z-body z-padding10 z-body-bottom0 mescroll" id="z-notice-mescroll">
      <div class="z-notice-items">
        <template v-for="(item,index) in data">
          <router-link :to="{path:'/index/noticeDetail',query:{id:item.id}}">
            <div class="z-notice-item">
              <div>
                <div v-text="item.title" class="z-notice-title"></div>
                <div v-text="item.atime" class="z-notice-time"></div>
              </div>
              <div>
                <img src="../../assets/index/toright.png" class="z-icon">
              </div>
            </div>
          </router-link>
        </template>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'notice',
    data() {
      return {
        mescroll: null,
        data: [],
        currApi:'',
        currTitle:'',
        obj:{
          notice:{
            title:'公告列表',
            api:'api/index/notice_list',
          },
          kuaixun:{
            title:'新闻列表',
            api:'api/futures/newLists',
          },
        }
      }
    },
    mounted() {
      this.currApi = this.obj[this.$route.query.type]['api']
      this.currTitle = this.obj[this.$route.query.type]['title']
      this.mescrollInit()
    },
    methods: {
      // mescroll组件初始化的回调,可获取到mescroll对象
      mescrollInit() {
        let _this = this;
        _this.mescroll = new MeScroll("z-notice-mescroll", {
          up: {
            callback: _this.upCallback
          }
        })
      },
      // 上拉回调 page = {num:1, size:10}; num:当前页 ,默认从1开始; size:每页数据条数,默认10
      upCallback(page, mescroll) {
        let _this = this
        _this.getList(page.num, function(rs) {

        })
      },
      getList(pageIndex, callback) {
        let _this = this
        // 联网请求
        this.get(_this.currApi, {
          page: pageIndex, // 页码
          limit: 15 // 每页长度
        }).then((rs) => {
          let arr = rs.data.data
          // 如果是第一页需手动置空列表
          if (pageIndex === 1) {
            _this.data = []
          }

          if (arr.length == 0) {
            _this.$store.commit('layer', '暂无数据')
          } else {
            // 把请求到的数据添加到列表
            _this.data = _this.data.concat(arr)
          }
          callback && callback(rs)
          // 数据渲染成功后,隐藏下拉刷新的状态
          _this.$nextTick(() => {
            _this.mescroll.endSuccess(arr.length)
          })

        }).catch((e) => {
          // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
          _this.mescroll.endErr()
        })
      },
    },
    destroyed: function() {},
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .z-notice-items {
    display: -webkit-flex;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }

  .z-notice-title {
    color: #fff;
    font-size: 15px;
    font-weight: 560;
  }

  .z-notice-time {
    padding-top: 5px;
    color: #B6B6B6;
  }

  .z-notice-item {
    display: -webkit-flex;
    display: flex;
    justify-content: space-between;
    padding: 10px 0px;
    align-items: center;
    border-bottom: 1px solid #ddd;
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/notice.vue